const sceneWrapperTheme = () => ({
  widthDesktop: 'calc(100% - 260px)',
  widthLaptop: 'calc(100% - 230px)',
});

export default sceneWrapperTheme;
